import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-1775">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-1776">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-1777">
          Diamond Abrasive Saw
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-1778">
          Precision Cutting for Non-Conductive Materials
        </p>
      </div>
    </div>;
}